import { BigNumber } from "bignumber.js"

export { BigNumber }

export type BigNumberLike = BigNumber | string | number | bigint

export const bn = (
  value: BigNumberLike,
  decimals?: number | null,
): BigNumber => {
  try {
    // toString() is used because numbers with more than 15 significant digits are not accepted
    return new BigNumber(value.toString()).shiftedBy(-(decimals ?? 0))
  } catch {
    return new BigNumber(Number.NaN)
  }
}
